import React from 'react';

const IconTarget = props => {
  const { color } = props;
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_9204_12936)">
        <circle cx="13.5" cy="13.5" r="13.5" fill={color} fill-opacity="0.17" />
      </g>
      <circle cx="13.5" cy="13.5" r="6.5" fill={color} />
      <defs>
        <filter id="filter0_b_9204_12936" x="-4" y="-4" width="35" height="35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9204_12936" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9204_12936" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
export default IconTarget;
